import { ListenerStore } from "../ListenerStore.js";
import type { BotType } from "./BotType.js";
import type { Ruleset } from "./Ruleset.js";
import type { GameMode } from "./GameMode.js";
import { LobbySettings } from "./LobbySettings.js";
import type { GameSettings } from "../../royalur/model/GameSettings.js";


export type RemoteSettingsListener = (resolvedSettings: LobbySettings) => void;


/**
 * Used for game settings where the game settings need to be retrieved
 * from a remote server.
 */
export class RemoteLobbySettings extends LobbySettings {
    private readonly resolveListeners: ListenerStore<RemoteSettingsListener>;

    constructor(lobbyID: string) {
        super(false, lobbyID);
        this.resolveListeners = new ListenerStore<RemoteSettingsListener>();
    }

    addResolveListener(listener: RemoteSettingsListener): () => void {
        return this.resolveListeners.add(listener);
    }

    override getLobbyID(): string {
        const lobbyID = super.getLobbyID();
        if (lobbyID === null)
            throw new Error("Missing lobby ID, but there should definitely be a lobby ID!");

        return lobbyID;
    }

    override isRemote(): boolean {
        return true;
    }

    override getMode(): GameMode {
        throw new Error("Game mode is not yet available");
    }

    override getRuleset(): Ruleset {
        throw new Error("Game type is not yet available");
    }

    override getGameSettings(): GameSettings {
        throw new Error("Game settings are not yet available");
    }

    override getCustomGameSettings(): GameSettings {
        throw new Error("Custom game settings are not yet available");
    }

    override getBotType(): BotType {
        throw new Error("Bot type is not yet available");
    }

    override toJSON(): string {
        throw new Error("Settings are not yet available");
    }

    override equals(other: LobbySettings): boolean {
        if (!(other instanceof RemoteLobbySettings))
            return false;

        return this.getLobbyID() === other.getLobbyID();
    }
}
